<script setup lang="ts">
import { MPrice, type Locale } from "@mindshift/cake-mindshift-next";
import { usePageStore } from "@reco/widgets/src/stores/pageStore";
import { getPriceFormatForLocale } from "@reco/widgets/src/utils";
import { computed } from "vue";

defineProps<{
  price: string;
  hasStar: boolean;
  displayedCurrency?: string;
}>();

const { normalizedLocale } = usePageStore();
const format = computed(() => getPriceFormatForLocale(normalizedLocale as Locale));

const handleDisclaimerClick = (e: MouseEvent) => {
  e.preventDefault();
  document.querySelector<HTMLAnchorElement>(".delivery-charges__button")?.click();
};
</script>

<template>
  <MPrice
    :price="price"
    :locale="normalizedLocale as Locale"
    :has-star="hasStar"
    :displayed-currency="displayedCurrency"
    :format="format"
    :is-new-price="true"
    :variant="'medium'"
  >
    <template #vat>
      <span>{{ $t("reco-frontend-next.Bundles.price_subtitle") }}</span>
      {{ " " }}
      <a href="#" target="_self" class="ods-link" @click="handleDisclaimerClick">
        {{ $t("reco-frontend-next.Bundles.price_subtitle_link_text") }}
      </a>
    </template>
  </MPrice>
</template>

<style lang="scss">
.reco-bundles {
  &__products {
    .ods-tile__inner {
      @media (max-width: 410px) {
        max-width: 45vw;
      }
    }
  }

  &__total-price {
    .ods-price__value {
      font-size: 2.25rem !important;
    }

    .ods-price__main-wrapper {
      align-items: center !important;
    }

    .ods-link {
      color: var(--ods-color-text-surface-interaction-link-default) !important;

      &:focus-visible {
        outline: none;
        box-shadow: 0 0 0 2px var(--ods-color-border-interaction-primary-default);
      }
    }

    @media screen and (min-width: $ods-breakpoint-desktop-min) {
      .ods-price__value {
        font-size: 3rem !important;
      }
    }
  }
}
</style>
